import React from "react";
import { useNavigate } from "react-router-dom";
import TopMenu from "../../components/TopMenu/TopMenu";
import BottomNav from "../../components/BottomNav/BottomNav";
import "./Cadastros.css";

export default function Cadastros() {
  const navigate = useNavigate();

  function chooseOnline() {
    navigate("/plantoes-cadastrados?tipo=online");
  }

  function choosePresencial() {
    navigate("/cadastros/local");
  }

  return (
    <div className="cadastros-page">
      <TopMenu />

      <main className="cadastros-content">
        <section className="cadastros-hero">
          <p className="cadastros-hero-title">Cadastros</p>
          <p className="cadastros-hero-subtitle">Escolha o tipo de cadastro</p>
        </section>

        <section className="cadastros-action-section">
          <ul className="cadastros-action-list">
            <li>
              <button
                type="button"
                className="cadastros-action-button"
                onClick={chooseOnline}
              >
                Online
              </button>
            </li>
            <li>
              <button
                type="button"
                className="cadastros-action-button"
                onClick={choosePresencial}
              >
                Presencial
              </button>
            </li>
          </ul>
        </section>
      </main>

      <BottomNav />
    </div>
  );
}
